export default __webpack_public_path__ + "cbfbc2e0f98313417aa8cfcb4cd41b5f.png";